import * as CONFIGS from "@/statics/configs.js";

const NODE18 = {
  NAME: "TS4C",
  INPUT1: {
    NAME: "NODE18_INPUT1_NAME",
    TYPE: "zeroContact",
    ICON: "switch",
    PARAMETER_ID: 0x8020,
  },
  INPUT2: {
    NAME: "NODE18_INPUT2_NAME",
    TYPE: "zeroContact",
    ICON: "switch",
    PARAMETER_ID: 0x8021,
  },
  INPUT3: {
    NAME: "NODE18_INPUT3_NAME",
    TYPE: "zeroContact",
    ICON: "switch",
    PARAMETER_ID: 0x8022,
  },
  INPUT4: {
    NAME: "NODE18_INPUT4_NAME",
    TYPE: "zeroContact",
    ICON: "switch",
    PARAMETER_ID: 0x8023,
  },
  OUTPUT1: {
    NAME: "NODE18_OUTPUT1_NAME",
    TYPE: "RelaySSR2A",
    ICON: "lamp",
    PARAMETER_ID: 0xe010,
  },
  OUTPUT2: {
    NAME: "NODE18_OUTPUT2_NAME",
    TYPE: "RelaySSR2A",
    ICON: "lamp",
    PARAMETER_ID: 0xe011,
  },
  OUTPUT3: {
    NAME: "NODE18_OUTPUT3_NAME",
    TYPE: "RelaySSR2A",
    ICON: "lamp",
    PARAMETER_ID: 0xe012,
  },
  OUTPUT4: {
    NAME: "NODE18_OUTPUT4_NAME",
    TYPE: "RelaySSR2A",
    ICON: "lamp",
    PARAMETER_ID: 0xe013,
  },
  TEMPERATURE: {
    NAME: "NODE18_TEMPERATURE_NAME",
    TYPE: "internalTemperature",
    ICON: "temperature",
    PARAMETER_ID: 0x8101,
  },
  NOTIFY_HUB: {
    PARAMETER_ID: 0x6100,
  },
  RELAY1_INIT: {
    PARAMETER_ID: 0xe110,
  },
  RELAY2_INIT: {
    PARAMETER_ID: 0xe111,
  },
  LORA_RSSI: {
    PARAMETER_ID: 0x8102,
  },
  LORA_SNR: {
    PARAMETER_ID: 0x8103,
  },
};
NODE18.DEFAULT_INSTRUCTIONS = [
  [
    {
      eventToWatch: {
        parameterId: NODE18.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE18.OUTPUT1.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_TOGGLE,
      },
      timeDelay: 0
    },
       {
      eventToWatch: {
        parameterId: NODE18.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE18.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE18.INPUT2.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE18.OUTPUT2.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_TOGGLE,
      },
      timeDelay: 0
    },
       {
      eventToWatch: {
        parameterId: NODE18.INPUT2.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE18.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE18.INPUT3.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE18.OUTPUT3.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_TOGGLE,
      },
      timeDelay: 0
    },
       {
      eventToWatch: {
        parameterId: NODE18.INPUT3.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE18.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE18.INPUT4.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE18.OUTPUT4.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_TOGGLE,
      },
      timeDelay: 0
    },
       {
      eventToWatch: {
        parameterId: NODE18.INPUT4.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE18.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
  ],
];

export default NODE18;
